'use client';

import { c as _c } from "react/compiler-runtime";
import { AbbreviatedHex } from '@repo/web3';
import { cn } from '../../utils/cn';
import { ClipboardButton } from './ClipboardButton';
export interface TextAddressProps {
  address: string;
  toastMessage: string;
  tooltipMessage?: string;
  className?: string;
}
export function TextAddress(t0) {
  const $ = _c(12);
  const {
    address,
    toastMessage,
    tooltipMessage,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("gap-2xs flex h-[25.6px] items-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== address) {
    t2 = <AbbreviatedHex value={address} className="text-foreground text-xs leading-normal" />;
    $[2] = address;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== address || $[5] !== toastMessage || $[6] !== tooltipMessage) {
    t3 = <ClipboardButton size="sm" toCopy={address} toastMessage={toastMessage} tooltipMessage={tooltipMessage} />;
    $[4] = address;
    $[5] = toastMessage;
    $[6] = tooltipMessage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}